// What the app does with the phone's browser and share sheet, done in the admin's browser.

type OpenWindow = (url?: string, target?: string, features?: string) => Window | null;

// The app opens previews and links in the in-app browser; the admin opens a new tab. The tab opens
// at once, while the click still counts as the Provider's, and goes to the URL once it is known:
// browsers block tabs opened after an awaited request.
export async function openInNewTab(
  getUrl: () => Promise<string>,
  open: OpenWindow = (...args) => window.open(...args)
) {
  const tab = open("", "_blank");
  try {
    const url = await getUrl();
    if (tab) {
      tab.opener = null;
      tab.location.href = url;
    } else {
      open(url, "_blank", "noopener,noreferrer");
    }
  } catch (error) {
    tab?.close();
    throw error;
  }
}

export function openUrl(url: string) {
  window.open(url, "_blank", "noopener,noreferrer");
}

// "Поділитися": the system share sheet where the browser has one, else the link is copied.
// Answers whether it was copied, so the page can say so.
export async function shareUrl(url: string): Promise<"shared" | "copied"> {
  if (typeof navigator.share === "function") {
    try {
      await navigator.share({ url });
    } catch {
      // Closing the share sheet is not an error.
    }
    return "shared";
  }
  await navigator.clipboard.writeText(url);
  return "copied";
}
